// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2mNrd","messages":"Chat_messages__22aME","dateDivider":"Chat_dateDivider__3xvzf"};